<template>
  <section>
    <b-button v-b-modal.expense-modal size="sm" variant="primary" class="mr-2"><i class="fa fa-plus" aria-hidden="true"></i> Add</b-button>
    <b-modal
      id="expense-modal"
      size="sm"
      @ok="onSubmit"
      @shown="initializeModal(true)"
      @hidden="onReset"
      title="Add/Edit Expense"
      :ok-title=" isSaving ? 'Submitting...' : 'Submit'"
      :ok-disabled="isSaving"
      header-close-label="Cancel"
      scrollable
    >
      <div class="modal-body">
        <b-row>
          <b-col cols="8">
            <b-form-group class="required" label="Expense date">
              <date-picker v-model="formData.expenseDate" :config="datePickerOptions"
                           :class="{ 'is-invalid': $v.formData.expenseDate.$error }"></date-picker>
              <b-form-invalid-feedback>Please select expense date</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="8">
            <b-form-group label="Source" class="mr-2">
              <b-form-select
                v-model="formData.sourceId"
                :plain="true"
              >
                <option
                  v-for="source in sortSelect(sourceIds)"
                  :key="source.id"
                  :value="source.id"
                >{{source.name}}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Reference No." class="mr-2" :class="{'required': formData.sourceId>0}">
              <b-form-input
                type="text"
                :class="{ 'is-invalid': $v.formData.referenceId.$error }"
                @blur="$v.formData.referenceId.$touch()"
                v-model.trim="formData.referenceId"
              ></b-form-input>
              <b-form-invalid-feedback>Please enter valid Reference No.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="8">
            <b-form-group label="Account" class="required mr-2">
              <b-form-select
                v-model="formData.accountId"
                :plain="true"
                :class="{ 'is-invalid': $v.formData.accountId.$error }"
              >
                <option
                  v-for="source in sortSelect(chartOfAccounts,'accountName')"
                  :key="source.id"
                  :value="source.id"
                >{{source.accountName}}
                </option>
              </b-form-select>
              <b-form-invalid-feedback>Please select account</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Amount" class="required mr-2">
              <b-form-input
                type="number"
                :class="{ 'is-invalid': $v.formData.amount.$error }"
                @blur="$v.formData.amount.$touch()"
                v-model.trim="formData.amount"
              ></b-form-input>
              <b-form-invalid-feedback>Amount should be > 0</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Description" class="mr-2">
              <b-form-input
                type="text"
                v-model.trim="formData.description"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </section>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex';
  import { required, decimal, requiredIf } from 'vuelidate/lib/validators';
  import { numberGreaterThan } from '@/shared/validators';
  import moment from 'moment';
  import {
    DATE_FORMAT, EXPENSE_SOURCE_IDS,
  } from '@/shared/constants';

  export default {
    name: 'edit',
    data() {
      return {
        formData: {
          id: 0,
          sourceId: 0,
          referenceId: '',
          accountId: '',
          amount: '',
          description: '',
          expenseDate: new Date(),
          active: true,
        },
        sourceIds: EXPENSE_SOURCE_IDS,
        chartOfAccounts: [],
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: true,
        },
        isSaving:false
      };
    },
    validations: {
      formData: {
        referenceId: {
          decimal,
          required: requiredIf(function() {
            return this.formData.sourceId;
          }),
        },
        amount: { required, decimal, numberGreaterThan: numberGreaterThan(0) },
        expenseDate: { required },
        accountId: { required },
      },
    },
    computed: {
      ...mapState('expenses', ['expense']),
    },
    methods: {
      ...mapMutations('expenses', ['setItem']),
      ...mapActions('expenses', ['getChartOfAccounts', 'manage']),
      async onSubmit(e) {
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          e.preventDefault();
          return;
        }
        try {
          this.isSaving=true;
          if (!this.formData.referenceId) {
            this.formData.referenceId = 0;
          }
          this.formData.expenseDate = new Date(this.formData.expenseDate).toISOString();
          const id = await this.manage(this.formData);
          this.isSaving=false;
          if (id) {
            this.onReset(true);
          } else {
            e.preventDefault();
          }
        } catch {
          e.preventDefault();
        }
      },
      onReset(updateList = false) {
        this.$emit('onChange', updateList);
        this.setItem({resource: 'expense', payload: {}});
      },
      async initializeModal(getData = false) {
        this.formData = {
          id: 0,
          sourceId: 0,
          referenceId: '',
          accountId: '',
          amount: '',
          description: '',
          expenseDate: new Date(),
          active: true,
        },
          this.$v.$reset();
        this.$v.formData.$reset();
        if (Object.entries(this.expense).length !== 0) {
          this.formData = { ...this.expense };
          this.formData.expenseDate = moment(this.formData.expenseDate).format(this.datePickerOptions.format);
        }
        if (getData) {
          this.chartOfAccounts = await this.getChartOfAccounts(7);
        }
      },
    },
    mounted() {

    },
  };
</script>
